/// <amd-module name="Comments/Reactions/Util" />
import { ICommentReaction } from "Comments/Common/Contracts";
import { ReactionTypeToEmojiMap } from "Comments/Reactions/Constants";
import { ICommentReactionTypeInfo, IReactionTypeToInfoMap } from "Comments/Reactions/Contracts";

export function createReactionsMap(commentReactions: ICommentReaction[]): IReactionTypeToInfoMap {
    return reactionsToReactionMap(commentReactions);
}

export function reactionsToReactionMap(reactions: ICommentReaction[]): IReactionTypeToInfoMap {
    const result: IReactionTypeToInfoMap = Object.keys(ReactionTypeToEmojiMap).reduce((accumulator, k) => {
        accumulator[Number(k)] = {
            totalCount: 0,
            isCurrentUserEngaged: false,
            engagedUsers: []
        };
        return accumulator;
    }, {} as IReactionTypeToInfoMap);

    const commentReactions: ICommentReaction[] = reactions || [];
    commentReactions.forEach((reaction: ICommentReaction) => {
        if (reaction) {
            const reactionTypeInfo: ICommentReactionTypeInfo = {
                totalCount: reaction.count,
                isCurrentUserEngaged: reaction.isCurrentUserEngaged,
                engagedUsers: [] // This will be updated later on when user hovers over this reaction
            };

            result[reaction.type] = reactionTypeInfo;
        }
    });

    return result;
}
